import {
  getTenantTimezoneCode as readTenantTimezoneCode,
  getTenantTimezoneName as readTenantTimezoneName,
} from './tenant-timezone'

export const extractTenant = () => {
  const hostname = window.location.hostname
  if (hostname.includes('.')) return hostname.split('.')[0] || 'default'
  return 'default'
}

export const extractTenantId = () => {
  const tenant = extractTenant()
  return tenant.includes('-donor') ? tenant.replace('-donor', '') : tenant
}

export const extractTenantFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('tenant') || urlParams.get('tenant_id')
}

export const isValidTenantId = tenantId => {
  if (!tenantId || typeof tenantId !== 'string') return false

  const tenantRegex = /^[a-zA-Z0-9-]{3,20}$/
  return tenantRegex.test(tenantId)
}

export const extractTenantInfo = () => {
  const currentTenant = extractTenant()
  const finalTenant = extractTenantId()
  const urlTenant = extractTenantFromUrl()

  return {
    hostname: window.location.hostname,
    currentTenant,
    finalTenant,
    urlTenant,
    isValid: isValidTenantId(finalTenant),
    url: window.location.href,
  }
}

export const getTenantTimezoneCode = () => {
  return readTenantTimezoneCode()
}

/** Tenant timezone abbreviation for display, e.g. `(PST)`. */
export const formatTenantTimezoneLabel = () => {
  const code = getTenantTimezoneCode()
  return code ? `(${code})` : ''
}

export const getTenantTimezoneName = () => {
  return readTenantTimezoneName()
}
